import { Fade } from "react-awesome-reveal";
import IntroSectionBadge from "../../../../components/intro-section-badge/intro-section-badge";
import CardDefault from "../../../../components/ui/cards/card-default/card-default";
import IconDescription from "../../../../components/ui/icon-description/icon-description";
import "./poles-where-to-use.scss";

const PolesWhereToUse = () => {
  return (
    <section className="poles-where-to-use">
      <Fade direction="up" duration={700} triggerOnce>
        <IntroSectionBadge
          badgeText={"IDEALI PER"}
          title={"Dove Utilizzare i Pali Rotoinfissi"}
          text={`Soluzioni versatili per ogni contesto costruttivo`}
          bgColor={"light"}
          icon="cube"
        />
      </Fade>
      <Fade direction="up" duration={800} delay={150} triggerOnce>
        <div className="poles-where-to-use__cards-list">
          <CardDefault type={"light"}>
            <IconDescription
              icon={"city"}
              title={"Cantieri in Aree Urbane"}
              text={
                "Perfetti per centri abitati e zone residenziali dove è fondamentale evitare vibrazioni."
              }
              type={"primary"}
              size={"big"}
              direction={"vertical"}
            />
          </CardDefault>
          <CardDefault type={"light"}>
            <IconDescription
              icon={"maximize"}
              title={"Ampliamenti Edilizi"}
              text={
                "Ideali per interventi di ampliamento di edifici esistenti senza compromettere le strutture adiacenti."
              }
              type={"secondary"}
              size={"big"}
              direction={"vertical"}
            />
          </CardDefault>
          <CardDefault type={"light"}>
            <IconDescription
              icon={"arrows-to-circle"}
              title={"Spazi Ristretti"}
              text={
                "Soluzione ottimale per fondazioni in spazi limitati dove altre tecnologie risulterebbero impraticabili."
              }
              type={"secondary"}
              size={"big"}
              direction={"vertical"}
            />
          </CardDefault>
          <CardDefault type={"light"}>
            <IconDescription
              icon={"layer-group"}
              title={"Terreni Vegetali"}
              text={
                "Tecnologia adatta a tutti i tipi di terreno vegetale, garantendo stabilità e ancoraggio efficaci."
              }
              type={"secondary"}
              size={"big"}
              direction={"vertical"}
            />
          </CardDefault>
        </div>
      </Fade>
    </section>
  );
};

export default PolesWhereToUse;
